import { combineReducers } from "redux";
import session from "./session";
import login from "./login";
import users from "./users";
import packages from "./packages/index";
import forgotPassword from "./forgotPassword";
import myProfile from "./myProfile";
import resetPassword from "./resetPassword";
import changePassword from "./changePassword";
import userChangePassword from "./userChangePassword";
import projects from "./projects/index";
import spools from "./spools/index";
import cutting from "./cutting";
import layout from "./layout";
import welcomeUser from "./welcomeUser";
import procurement from "./procurement";
import fieldMaterial from "./fieldMaterial";
import bom from "./bom";
import suppliers from "./suppliers";
import taskboard from "./taskboard";
import bols from "./bol/index";
import calendar from "./calendar";
import toolBar from "./toolbar";
import receivedBom from "./receivedBom";
import accessFiles from "./accessFiles";
import accessSpools from "./accessSpools";
import accessPackages from "./accessPackages";
import graphs from "./graphs";
import rejectedPackages from "./rejectedPackages";
import adminProcurementDashboard from "./adminProcurementDashboard";
import pagination from "./pagination";
import printLabels from "./printLabels";
import rejectPackage from "./rejectPackage";
import pipelines from "./pipelines";
import ganttChart from "./ganttChart/index";
import hangerItems from "./hangerItems";
import bomVersions from "./bomVersions";
import search from "./search";
import PMDashboard from "./PMDashboard";
import FFDashboard from "./FFDashboard";
import revisionReports from "./revisionReports";
import MtrManagement from "./mtrManagment";
import purchaseOrder from "./purchaseOrder";
import weldInspectionFiltersData from "./weldInspection";
import miscFabTask from "./miscFabTask";
import clients from "./clients";
import shopManager from "./ScheduleManager";
import integrations from "./Integrations";
import miscFabMaterial from "./MiscFabDashboard";
import packagesView from "./MiscFabDashboard/packagesView";
import hangerShop from "./HangerShop";
import addClients from "./addClient";
import exportData from "./ExportData";

const appReducer = combineReducers({
  session,
  login,
  users,
  packages,
  forgotPassword,
  myProfile,
  resetPassword,
  changePassword,
  layout,
  userChangePassword,
  projects,
  spools,
  cutting,
  welcomeUser,
  procurement,
  fieldMaterial,
  bom,
  suppliers,
  taskboard,
  bols,
  calendar,
  toolBar,
  receivedBom,
  accessFiles,
  accessSpools,
  accessPackages,
  graphs,
  adminProcurementDashboard,
  rejectedPackages,
  pagination,
  printLabels,
  rejectPackage,
  pipelines,
  ganttChart,
  hangerItems,
  bomVersions,
  search,
  PMDashboard,
  FFDashboard,
  revisionReports,
  MtrManagement,
  purchaseOrder,
  weldInspectionFiltersData,
  miscFabTask,
  clients,
  shopManager,
  integrations,
  miscFabMaterial,
  packagesView,
  hangerShop,
  addClients,
  exportData,
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
